import { Checkbox, Form, Row, Space } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { RuleObject } from 'antd/lib/form';
import React, { useContext } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import InfoTooltip from 'components/molecules/InfoTooltip';

import { EProfilyTyp } from 'enums/profilyTyp';

interface IOpravneniCheckboxy {
    onChange: (val: CheckboxValueType[]) => void;
    initialValue: (string | undefined)[] | undefined;
    disabled: boolean;
    checkboxIsAllSelected: boolean;
    mode: 'smsLogin' | 'zadostOOsoby' | 'zadostOAmlz' | 'zadostEdit' | 'C2' | 'displayOnly';
    isAmlzRequired?: boolean;
    enableAdvancedOptions?: boolean;
    formValue?: string[];
}

const OpravneniCheckboxy: React.FC<IOpravneniCheckboxy> = ({
    onChange,
    initialValue,
    disabled,
    checkboxIsAllSelected,
    mode,
    isAmlzRequired,
    enableAdvancedOptions,
    formValue
}) => {
    const { aktivniFirma } = useContext(Context);

    return (
        <Form.Item
            style={{
                marginBottom: 24
            }}
            name="opravneni"
            initialValue={initialValue}
            label={<Paragraph text="ZADOST_PRAVO_OPRAVNENI" strong={true} />}
            rules={[
                () => ({
                    validator(_rule: RuleObject, value: string[]) {
                        if (
                            (mode === 'zadostOAmlz' || (mode === 'C2' && isAmlzRequired)) &&
                            !value.includes('VSE') &&
                            !value.includes('AMLZ')
                        )
                            return Promise.reject(<TranslateText>AMLZ_C2_CHECKBOXERR_AML</TranslateText>);
                        if (mode === 'zadostOOsoby' && !value.includes('VSE') && !value.includes('UZIVATELE'))
                            return Promise.reject(<TranslateText>AMLZ_C2_CHECKBOXERR_OSOBY</TranslateText>);
                        return Promise.resolve();
                    }
                }),
                {
                    required: true,
                    message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                }
            ]}
        >
            <Checkbox.Group
                disabled={disabled}
                style={{
                    width: '100%',
                    marginBottom: 26
                }}
                onChange={onChange}
            >
                <Space direction="vertical">
                    <Checkbox
                        value={'VSE'}
                        disabled={!enableAdvancedOptions}
                        checked={!enableAdvancedOptions ? false : undefined}
                    >
                        <TranslateText>VSE</TranslateText>
                    </Checkbox>
                    {aktivniFirma?.typ !== EProfilyTyp.ADMEMIT && (
                        <>
                            {(mode === 'zadostOAmlz' || mode === 'C2') && (
                                <Row>
                                    <Checkbox
                                        checked={checkboxIsAllSelected}
                                        value={'AMLZ'}
                                        disabled={checkboxIsAllSelected}
                                        id="opravneni_AMLZ"
                                    >
                                        <TranslateText>ZADOST_PRAVO_AMLZ</TranslateText>
                                    </Checkbox>{' '}
                                    <InfoTooltip
                                        title={'ZADOST_PRAVO_AMLZ_TOOLTIP'}
                                        style={{
                                            position: 'relative',
                                            top: '2px'
                                        }}
                                    />
                                </Row>
                            )}
                            <Row>
                                <Checkbox
                                    checked={checkboxIsAllSelected ? false : undefined}
                                    value={'PRIKAZY'}
                                    disabled={checkboxIsAllSelected}
                                    id="opravneni_PRIKAZY"
                                >
                                    <TranslateText>ZADOST_PRAVO_PRIKAZY</TranslateText>
                                </Checkbox>{' '}
                                <InfoTooltip
                                    title={'ZADOST_PRAVO_PRIKAZY_TOOLTIP'}
                                    style={{
                                        position: 'relative',
                                        top: '2px'
                                    }}
                                />
                            </Row>
                            <Checkbox
                                checked={checkboxIsAllSelected ? false : undefined}
                                value={'SMLOUVY'}
                                disabled={checkboxIsAllSelected}
                                id="opravneni_SMLOUVY"
                            >
                                <TranslateText>ZADOST_PRAVO_SMLOUVY</TranslateText>
                            </Checkbox>{' '}
                        </>
                    )}
                    {(mode === 'zadostOOsoby' || mode === 'zadostEdit') && (
                        <Checkbox
                            checked={checkboxIsAllSelected}
                            value={'UZIVATELE'}
                            disabled={checkboxIsAllSelected}
                            id="opravneni_UZIVATELE"
                        >
                            <TranslateText>ZADOST_PRAVO_UZIVATELE</TranslateText>
                        </Checkbox>
                    )}
                    <Checkbox
                        checked={checkboxIsAllSelected || !enableAdvancedOptions ? false : undefined}
                        value={'VYPIS'}
                        disabled={checkboxIsAllSelected || !enableAdvancedOptions}
                        id="opravneni_VYPIS"
                    >
                        <TranslateText>ZADOST_PRAVO_VYPIS</TranslateText>
                    </Checkbox>{' '}
                    {!!formValue && (formValue?.includes('VYPIS') || formValue?.includes('VSE')) && (
                        <Row>
                            <Checkbox
                                checked={checkboxIsAllSelected || !enableAdvancedOptions ? false : undefined}
                                value={'VIDETVYPIS'}
                                disabled={checkboxIsAllSelected || !enableAdvancedOptions}
                                id="opravneni_VIDETVYPIS"
                            >
                                <TranslateText>ZADOST_PRAVO_VIDETVYPIS</TranslateText>
                            </Checkbox>{' '}
                            <InfoTooltip
                                title={'ZADOST_PRAVO_VIDETVYPIS_TOOLTIP'}
                                style={{
                                    position: 'relative',
                                    top: '2px'
                                }}
                            />
                        </Row>
                    )}
                    <Row>
                        <Checkbox
                            checked={checkboxIsAllSelected || !enableAdvancedOptions ? false : undefined}
                            value={'UPIS'}
                            disabled={checkboxIsAllSelected || !enableAdvancedOptions}
                            id="opravneni_UPIS"
                        >
                            <TranslateText>ZADOST_PRAVO_UPIS</TranslateText>
                        </Checkbox>{' '}
                        <InfoTooltip
                            title={'ZADOST_PRAVO_UPIS_TOOLTIP'}
                            style={{
                                position: 'relative',
                                top: '2px'
                            }}
                        />
                    </Row>{' '}
                    <Row>
                        <Checkbox
                            checked={checkboxIsAllSelected || !enableAdvancedOptions ? false : undefined}
                            value={'UPISSICAV'}
                            disabled={checkboxIsAllSelected || !enableAdvancedOptions}
                            id="opravneni_UPISSICAV"
                        >
                            <TranslateText>ZADOST_PRAVO_UPISSICAV</TranslateText>
                        </Checkbox>{' '}
                        <InfoTooltip
                            title={'ZADOST_PRAVO_UPIS_TOOLTIP'}
                            style={{
                                position: 'relative',
                                top: '2px'
                            }}
                        />
                    </Row>
                    <Row>
                        <Checkbox
                            checked={checkboxIsAllSelected || !enableAdvancedOptions ? false : undefined}
                            value={'SRD'}
                            disabled={checkboxIsAllSelected || !enableAdvancedOptions}
                            id="opravneni_SRD"
                        >
                            <TranslateText>ZADOST_PRAVO_SRD</TranslateText>
                        </Checkbox>{' '}
                        <InfoTooltip
                            title={'ZADOST_PRAVO_SRD_TOOLTIP'}
                            style={{
                                position: 'relative',
                                top: '2px'
                            }}
                        />
                    </Row>
                    {/* <Row>
                                        <Radio value={'ADMEMIT'}>
                                            <TranslateText>Administrátor emise</TranslateText>
                                        </Radio>
                                        {form.getFieldValue('opraveneni') === 'ADMEMIT' && (
                                            <InputComponent
                                                label={'ICO'}
                                                name="registrationauthorityentityid"
                                                initialValue={personData?.ico}
                                                rules={icoValidation()}
                                                maxLength={30}
                                            />a
                                        )}
                                        </Row> */}
                    {!enableAdvancedOptions && (
                        <Paragraph
                            text="ZADOST_PRAVO_TEXT"
                            style={{
                                fontWeight: 700
                            }}
                        />
                    )}
                    <Paragraph
                        text="ZADOST_PRAVO_TEXT2"
                        style={{
                            fontWeight: 700
                        }}
                    />
                </Space>
            </Checkbox.Group>
        </Form.Item>
    );
};
export default OpravneniCheckboxy;
